text-center<template>
  <section id="pricing" class="pb-8">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-card style="width: 100%">
            <!-- <h1 class="text-center pt-6 font-weight-light display-2">Planos</h1> -->
            <v-divider class="my-6"></v-divider>
            <v-row class="text-center">
              <v-col class="col-12 col-sm-6 col-md-4 col">
                <div class="flex-center">
                  <v-card-text>
                    <div class="flex-center">
                      <div class="circle1">
                        <div class="circle2">
                          <v-img src="@/assets/img/jzxznlhxt.png"></v-img>
                        </div>
                      </div>
                    </div>
                    <div class="text-uppercase text-h5 my-2">集装箱智能理货系统</div>
                    <v-divider class="my-2"/>
                    <div class="text-uppercase blue--text">Tallying System</div>
                    <v-divider class="my-2"/>
                    <div class="text-uppercase text--disabled text-left">
                  通过摄像头、视频监控控技术、智能识别技术识别岸吊操作及集装箱信息，并自动提交到CTOS系统，
                  实现集装箱码头船岸理货过程的无人化、智能化、从而减少码头面人工作业，消除安全隐患，减少人员配置，降低用工成本，提高理货效率。
                </div>
                    
                  </v-card-text>
                  <v-divider style="margin-right: -23px" vertical v-if="this.$vuetify.breakpoint.smAndUp"></v-divider>
                </div>
                <v-divider class="mx-4" v-if="!this.$vuetify.breakpoint.smAndUp"></v-divider>
              </v-col>
              <v-col class="col-12 col-sm-6 col-md-4 col">
                <div class="flex-center">
                  <v-card-text>
                    <div class="flex-center">
                      <div class="circle1">
                        <div class="circle2">
                          <v-img src="@/assets/img/mtznzkxt.jpg"/>
                        </div>
                      </div>
                    </div>
                    <div class="text-uppercase text-h5 my-2">码头智能闸口系统</div>
                    <v-divider class="my-2"/>
                    <div class="text-uppercase blue--text">Gate System</div>
                    <v-divider class="my-2"/>
                    <div class="text-uppercase text--disabled text-left">
                  通过摄像头、视频监控控技术、智能识别技术识别进出闸口的集卡及其背箱信息，自动提交CTOS系统，并在允许时发送抬杠指令，远程控制抬杠操作，
                  实现进出闸口无人化管理，一个员工可同时监控多条闸口通道、从而减少人员配置，降低用工成本，提高工作效率。
                </div>
                    
                  </v-card-text>
                  <v-divider style="margin-right: -23px" vertical v-if="this.$vuetify.breakpoint.mdAndUp"></v-divider>
                </div>
                <v-divider class="mx-4" v-if="!this.$vuetify.breakpoint.smAndUp"></v-divider>
              </v-col>
              <v-col class="col-12 col-sm-6 col-md-4 col">
                <div class="flex-center">
                  <v-card-text>
                    <div class="flex-center">
                      <div class="circle1">
                        <div class="circle2">
                          <v-img src="@/assets/img/mtznzxsxt.jpg"/>
                        </div>
                      </div>
                    </div>
                    <div class="text-uppercase text-h5 my-2">码头智能装卸锁系统</div>
                    <v-divider class="my-2"/>
                    <div class="text-uppercase blue--text">Loading and unloading lock System</div>
                    <v-divider class="my-2"/>
                    <div class="text-uppercase text--disabled text-left">
                 通过实时获取理货计划指令信息，根据逻辑计算集卡上的集装箱是否需要装卸锁，并发送信息到集卡终端（包括LED屏和安卓手机），
                  从而减少许多不必要的工作量，提高工作效率。
                </div>
                    
                  </v-card-text>
                  <v-divider style="margin-right: -23px" vertical v-if="this.$vuetify.breakpoint.mdAndUp"></v-divider>
                </div>
                <v-divider class="mx-4" v-if="!this.$vuetify.breakpoint.smAndUp"></v-divider>
              </v-col>
              <!-- <v-col class="col-12 col-sm-6 col-md-4">
                <v-divider v-if="this.$vuetify.breakpoint.smOnly" class="mx-4"></v-divider>

                <div class="flex-center">
                  <v-card-text>
                    <div class="flex-center">
                      <div class="circle1">
                        <div class="circle2">
                          <v-img src="@/assets/img/mtznzxsxt.jpg"/>
                        </div>
                      </div>
                    </div>
                    <div class=" text-uppercase text-h5 my-2">码头智能装卸锁系统</div>
                    <v-divider class="my-2"/>
                    <div class="text-uppercase blue--text">Loading and unloading lock System</div>
                    <v-divider class="my-2"/>
                    <div class="text-uppercase text--disabled text-left">
                  通过实时获取理货计划指令信息，根据逻辑计算集卡上的集装箱是否需要装卸锁，并发送信息到集卡终端（包括LED屏和安卓手机），
                  从而减少许多不必要的工作量，提高工作效率。
                </div>
                   
                  </v-card-text>
                </div>
              </v-col> -->
              <v-col class="col-12 col-sm-6 col-md-4 col">
                <div class="flex-center">
                  <v-card-text>
                    <div class="flex-center">
                      <div class="circle1">
                        <div class="circle2">
                          <v-img src="@/assets/img/mtyybbxt.jpg"></v-img>
                        </div>
                      </div>
                    </div>
                    <div class="text-uppercase text-h5 my-2">码头语音播报系统</div>
                    <v-divider class="my-2"/>
                    <div class="text-uppercase blue--text">Voice broadcasting System</div>
                    <v-divider class="my-2"/>
                    <div class="text-uppercase text--disabled text-left">
                  实现码头智能播报的功能及管理。该系统可以提升码头工作人员的用户体验，提高工作效率。
                  本系统可以混用多种终端使用，同时降低运维压力。
                  播报服务端和安卓端之间采用了WebSocket的传输方式。播报服务端在处理消息时采用了多线程，来提高软件的运行效率。
                  管理端采用了Form界面和WcfService服务结合的方案，有更强的安全性和兼容性。
                </div>
                    
                  </v-card-text>
                  <v-divider style="margin-right: -23px" vertical v-if="this.$vuetify.breakpoint.smAndUp"></v-divider>
                </div>
                <v-divider class="mx-4" v-if="!this.$vuetify.breakpoint.smAndUp"></v-divider>
              </v-col>
              <v-col class="col-12 col-sm-6 col-md-4 col">
                <div class="flex-center">
                  <v-card-text>
                    <div class="flex-center">
                      <div class="circle1">
                        <div class="circle2">
                          <v-img src="@/assets/img/mtzncxdwxt.png"></v-img>
                        </div>
                      </div>
                    </div>
                    <div class="text-uppercase text-h5 my-2">码头智能船箱定位系统</div>
                    <v-divider class="my-2"/>
                    <div class="text-uppercase blue--text">Ship box positioning System</div>
                    <v-divider class="my-2"/>
                    <div class="text-uppercase text--disabled text-left">
                    从摄像头安装位置优化和基于人工智能的图像识别技术入手，利用人工智能技术和计算机视觉技术识别作业节点，以及传统的光学字符识别系统(OCR)识别率低的问题，引入人工智能技术改进方案。在箱子离开地面前进行识别和确认。

                </div>
                    
                  </v-card-text>
                  <v-divider style="margin-right: -23px" vertical v-if="this.$vuetify.breakpoint.smAndUp"></v-divider>
                </div>
                <v-divider class="mx-4" v-if="!this.$vuetify.breakpoint.smAndUp"></v-divider>
              </v-col>
              
              
            
               <v-col class="col-12 col-sm-6 col-md-4">
              <v-img src="@/assets/img/ill2.svg" class="d-block ml-auto mr-auto lastImg" max-width="325px" />
            </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-rounded text-light">
      <!-- <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 144.54 17.34"
        preserveAspectRatio="none"
        fill="currentColor"
      >
        <path
          d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0"
        />
      </svg> -->
      <!-- <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
          fill="currentColor"
      >
        <path
            d="M0,64L80,90.7C160,117,320,171,480,181.3C640,192,800,160,960,138.7C1120,117,1280,107,1360,101.3L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
        ></path>
      </svg> -->
    </div>
  </section>
</template>

<style lang="scss">
$main_color: #283e79;

ul {
  font-size: 13px;
  line-height: 1.5em;
  margin: 5px 0 15px;
  padding: 0;

  li {
    list-style: none;
    position: relative;
    padding: 0 0 0 20px;
  }

  li {
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 5px;
      width: 10px;
      height: 10px;
      background-color: $main_color;
      border-radius: 50%;
      -moz-border-radius: 50%;
      -webkit-eeborder-radius: 50%;
    }
  }
}
</style>

<style scoped>

.header {
  background-color: #283e79;
  color: white;
}

.circle1 {
  border-radius: 50%;
  width: 400px;
  height: 400px;
  background-color: #f0f8ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle2 {
  border-radius: 50%;
  width: 400px;
  height: 100px;
  background-color: #e0effc;
  display: flex;
  align-items: center;
  justify-content: center;
}


.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.svg-border-rounded svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  color: #f4f7f5;
  z-index: -1;
}


#pricing {
  z-index: 0;
}

.content {
  z-index: 1;
}

svg {
  overflow: hidden;
}

section {
  position: relative;
}
.text-left{
  text-align: left;
  text-indent: 2em;
}
.col{
  padding: 0;
}
.lastImg{
  margin-top: 20px;
  margin-bottom: 20px;
  }
  
@media screen and (min-width: 0px) and (max-width: 768px) {
  .circle1 {
    width: 200px;
    height: 200px;
  }
  .circle2 {
    width: 200px;
    height: 50px;
  }
  .lastImg{
    width: 70%;
 
  }
  
}
</style>

<script>
export default {

};
</script>